import React, { useEffect, useState, useRef } from "react";
import Header from "../components/Header";
import { Link , useNavigate ,} from "react-router-dom";
import { useForm } from "react-hook-form";
import {alert, confirm} from "../components/MegConfirmAlert";
import { BsExclamationCircleFill } from "react-icons/bs";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";


export default function DeleteAccount() {
    const { t } = useTranslation();
    const {register, handleSubmit, formState }= useForm();
    const{errors} = formState;
    const userInfo = JSON.parse(localStorage.getItem("user")).data;
    const [isAgr, setAgr] = useState(false);
    const [request] = useAxios();
    const navigate = useNavigate();

    const onSubmit =  async data=> {
        console.log(data)
        if(!isAgr){
            alert(t(`Message.delete_account_read_percaution`))
            return
        }

        const response = await request.post("/app/member/getCheckUserPwdAPI", {
            userId : userInfo.userId,
            password : data.password
        });

        if(response.data.resultCode === 200){
            const result = await confirm(t(`Message.delete_account_sure_withdraw`), {okText : t(`Message.common_yes`) , cancelText : t(`Message.common_no`)});
            if(result){
                const response2 = await request.post("/app/member/procMemberLeaveAPI", {
                    userId : userInfo.userId,
                    password : data.password,
                    leaveResn : data.leaveResn
                });
                if(response2.data.resultCode === 200){
                    await  alert(t(`Message.delete_account_success_withdraw1`) + t(`Message.delete_account_success_withdraw2`) , {okText : t(`Message.common_ok`)}); 
                    localStorage.removeItem("user");
                    localStorage.removeItem("cartCookie");
                    localStorage.removeItem("accessToken");
                    localStorage.removeItem("refreshToken");
                    navigate("/", { replace: true });             
                   
                }else{
                    alert(response.data.resultMessage)
                }
            }
        }else{
            alert(t(`Message.change_member_info_pw_not_match`))
        }

    }

    const byebye = () => {
        alert(t(`Message.delete_account_success_withdraw1`) + t(`Message.delete_account_success_withdraw2`) , {okText : t(`Message.common_ok`)}); 
    }

    return (
        <div>
            <Header type="black" pageTitle={t(`Message.delete_account_withdraw_membership`)}/>

            <div className="changeInfo">
                <div className="notice">
                    <BsExclamationCircleFill className="cOrg fs30 mb12"/>
                    <p className="idLi">{t(`Message.delete_account_notice_withdrawal_title`)}</p>
                    <div className="returnCaution">
                        <p>{t(`Message.delete_account_notice_withdrawal1`)}</p>
                        <p>{t(`Message.delete_account_notice_withdrawal2`)}</p>
                        <p>{t(`Message.delete_account_notice_withdrawal3`)}</p>
                        <p>{t(`Message.delete_account_notice_withdrawal4`)}</p>
                    </div>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <ul className="dfColG20">
                        <li className="idLi">
                            <p>{t(`Message.personal_sign_up_info_input_action_pwd`)}</p>
                            <input type="password" placeholder={t(`Message.change_member_info_enter_pw`)} {...register("password", { required: "필수 응답 항목입니다.", minLength:{ value:8, message: "비밀번호는 8자 이상이여야 합니다." }})} />
                            {errors.password && <p role="alert" className="alertRed">{errors.password.message}</p>}
                        </li>
                        <li className="idLi">
                            <p>{t(`Message.delete_account_q_uncomfortable`)}</p>
                            <textarea {...register("leaveResn")}></textarea>
                        </li>
                        <li className="chkWr">
                            <input type="checkbox" name="out" id="out" onChange={(e)=>{setAgr(e.target.checked)}}/>
                            <label htmlFor="out">{t(`Message.delete_account_agree_notice_withdrawal`)}</label>
                        </li>
                    </ul>
                    <div className="dfcsG8 mt40">
                        <Link to="/MyPage" className="cDisa fffB btn44">{t(`Message.common_cancel`)}</Link>
                        <button 
                            type="submit"
                            className="btn44 cFFF navyB"                           
                        >
                            {t(`Message.delete_account_withdraw_membership`)}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};